import axios from 'axios'
import resolveRequest from '../../utils/resolveRequest.js'
import { apiEndpoints, SERVER_PATH } from '../endpoints.js'

export default async (campaignObject, campaignId) => {
  const endpoint = `${apiEndpoints.campaigns}/${campaignId}`
  const URL = SERVER_PATH + endpoint
  return resolveRequest(axios.put(URL, campaignObject, { withCredentials: true }))
}
